import { DropdownCategory } from "@/api";

/**
 * Maximum value length per dropdown category, mirroring the backend `DropdownCategoryDefinitions`
 * (SONeu.Domain). Each limit is the smallest maximum length of the fields the category's values
 * are used in, so a configured value fits everywhere it appears.
 */
export const DropdownCategoryMaxLength: Record<DropdownCategory, number> = {
  [DropdownCategory.Salutation]: 12,
  [DropdownCategory.Title]: 20,
  [DropdownCategory.Citizenship]: 50,
  [DropdownCategory.MediaInquiry]: 50,
  [DropdownCategory.ContactSource]: 30,
  [DropdownCategory.Country]: 30,
  [DropdownCategory.City]: 30,
  [DropdownCategory.EmploymentStatus]: 50,
  [DropdownCategory.AssignmentPriority]: 50,
  [DropdownCategory.CaseNoteLocation]: 30,
  [DropdownCategory.AppointmentLocation]: 50,
  [DropdownCategory.CaseNoteResult]: 40,
  [DropdownCategory.Qualification]: 30,
  [DropdownCategory.MaritalStatus]: 30,
  [DropdownCategory.LivingSituation]: 50,
  [DropdownCategory.ClientGoalAndResult]: 50,
  [DropdownCategory.ClientMeasures]: 50,
  [DropdownCategory.ClientCauses]: 50,
  [DropdownCategory.ClaimLegalBasis]: 50,
  [DropdownCategory.Recommendation]: 30,
  [DropdownCategory.RegisteredBy]: 50,
  [DropdownCategory.Team]: 50,
  [DropdownCategory.WorkArea]: 50,
  [DropdownCategory.SrvCounselingType]: 50,
  [DropdownCategory.SrvCourseEntryResult]: 50,
  [DropdownCategory.IdentityDocumentType]: 50,
};
